import { CoreStore } from '../../../../core/store/core.store';
import { LoginService } from '../../services/login.service';
import { getEmailVerificationScreenState, getLoginUser } from '../../store/login.selectors';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ErrorCode, retrieveFirstErrorCode } from '@ppl/auth';
import { getAppAbsoluteURL } from '@ppl/core';
import { I18nService } from '@ppl/i18n';
import { Unsubscribe } from '@ppl/utils/angular.utils';
import { wrapAPICall } from '@ppl/utils/api.utils';
import { unsubscribe } from '@ppl/utils/subscription.utils';
import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { getSendVerificationLinkToEmailError, type EmailVerificationError } from '@ppl/email-verification-shared';
import type { Subscription } from 'rxjs';
import type { Translations } from '../../../../../translations';


@Component({
    selector: 'ppl-email-verification-screen',
    templateUrl: './email-verification-screen.component.html',
    styleUrl: './email-verification-screen.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
@Unsubscribe()
export class EmailVerificationScreenComponent {

  resendingVerificationEmail$ = new BehaviorSubject<boolean>(false);

  screenState$ = this.store.select(getEmailVerificationScreenState);

  isEmailVerified$ = this.screenState$.pipe(map(state => state.email_verified));
  user$ = this.store.select(getLoginUser);
  email$ = this.user$.pipe(map(user => user.email));
  emailVerificationError$ = new BehaviorSubject<EmailVerificationError>(null);

  ErrorCode = ErrorCode;

  resendVerificationEmailSubscription: Subscription;

  constructor(
    private store: CoreStore,
    private loginService: LoginService,
    private i18nService: I18nService<typeof Translations>
  ) { }

  onLogin() {
    this.redirectTo('/login');
  }

  onResendEmail() {
    unsubscribe(this.resendVerificationEmailSubscription);
    this.resendVerificationEmailSubscription = wrapAPICall(
      this.loginService.resendVerificationEmail(),
      this.resendingVerificationEmail$
    ).subscribe({
      next: response => {
        if (response.error === ErrorCode.NO_ERROR) {
          if (response.redirect_url) {
            this.redirectTo(response.redirect_url);
          }
        } else {
          this.emailVerificationError$.next(this.getResendError(response.error));
        }
      },
      error: error => {
        const errorCode = retrieveFirstErrorCode(error);
        this.emailVerificationError$.next(this.getResendError(errorCode || ErrorCode.ERROR_UNKNOWN));
      }
    });
  }

  private redirectTo(url: string) {
    window.location.href = getAppAbsoluteURL(url);
  }

  private getResendError(errorCode: ErrorCode): EmailVerificationError {
    return getSendVerificationLinkToEmailError(this.i18nService, errorCode);
  }
}
